import React from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import ListingVideo from '../ListingVideo/ListingVideo';
import css from './VideoSection.module.css';

const VideoSection = ({ currentListing }) => {
  const videoLink = currentListing?.attributes?.publicData?.youtubeLink;
  const isExperienceType =
    currentListing?.attributes?.publicData?.listingType === 'impact-experience';

  if (!videoLink) {
    return null;
  }

  return (
    <section className={css.section} data-elbaction="visible:vis ytvideo">
      <h2 className={css.title}>
        {isExperienceType ? (
          <FormattedMessage id="VideoSection.experienceTitle" />
        ) : (
          <FormattedMessage id="listingPage.videoSection.title" />
        )}
      </h2>
      <div className={css.playerWrap}>
        <ListingVideo currentListing={currentListing} className={css.playerInner} />
      </div>
    </section>
  );
};

export default VideoSection;
